import { useEffect, useState } from "react"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { ALIGN, ILandingSection, ImageContent, YamapContent } from "src/modules/pe-landing-module/data/interfaces"
import { getCssDemention } from "src/libs/utilities/getCssDemention"
import { getImageDemetions } from "src/modules/pe-landing-module/data/utils/getImageDemetions"
import "../../../assets/css/Image.scss" 
import YandexMapPrimitive from "../primitive/YandexMapPrimitive"
import DataContentEditor from "../landing-edit/editors/data-content-editor"

/* Protopia Ecosystem component */
export interface IImageProps {
    section: ILandingSection
    data: YamapContent 
}
const YandexMap = ({data, ...props}: IImageProps): JSX.Element => {
    const [marginLeft]    = useState<string>(!![ALIGN.END, ALIGN.MIDDLE ].find(e => e === data.horizontal_align)  || !data.horizontal_align ? "auto" : "0")
    const [marginRight]   = useState<string>(!![ALIGN.START, ALIGN.MIDDLE ].find(e => e === data.horizontal_align) || !data.horizontal_align ? "auto" : "0")
    const [marginTop]     = useState<string>(!![ALIGN.END, ALIGN.MIDDLE ].find(e => e === data.vertical_align) || !data.vertical_align ? "auto" : "0")
    const [marginBottom]  = useState<string>(!![ALIGN.START, ALIGN.MIDDLE ].find(e => e === data.vertical_align) || !data.vertical_align ? "auto" : "0")
    const [width]         = useState<string>(getCssDemention( data.width,  getCssDemention(props.section.width, "0px") ))
    const [height, ]      = useState<string>(
        getCssDemention( 
            data.height, 
            getCssDemention(
                props.section.height, 
                "0px"
            ) 
        )
    )
    useEffect(() => {
        addCSSClass(
            `landing-image-${props.section.id}`,
            `.landing-image-${props.section.id} {
                margin-left: ${marginLeft};
                margin-right: ${marginRight};
                margin-top: ${marginTop};
                margin-bottom: ${marginBottom};
                max-width: 100%;
                max-height: ${ height === "0px" ? getCssDemention(props.section.height, "300px") : height }; 
                height: ${ height === "0px" ? getCssDemention(props.section.height, "300px") : height };
                z-index:1;
                background-image:url(${ data.src });
                background-position-x: ${getCssDemention(data.background_position_x, "center")};

            } 
            .link-${props.section.id} {
                margin-left: ${marginLeft};
                margin-right: ${marginRight};
                margin-top: ${marginTop};
                margin-bottom: ${marginBottom};
                max-width: 100%;
                max-height: ${ height === "0px" ? getCssDemention(props.section.height, "300px") : height }; 
                height: ${ height === "0px" ? getCssDemention(props.section.height, "300px") : height };
                z-index:1;
            }
            `
        )
        
        return () => {
            removeCSSClass(`landing-image-${props.section.id}`)
        }
    },[  ])

    return <div className={` landing-content-container `}>
        <div className={`landing-ymap landing-ymap-${props.section.id} ${ data.className || "" } `} style={ data.style || {} }  data-type={data.type} data-content-id={data.id}>
            <YandexMapPrimitive  
                primitive={{
                    ...(data ),
                    height: props.section.height || 500
                } as any }  
            />
        </div>     
        <DataContentEditor data={data} section={props.section} /> 
    </div>
}
export default YandexMap